import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InformationComponent } from './primary/information/information.component';
import { BussnessInformationComponent } from './primary/bussness-information/bussness-information.component';
import { PrimaryAccountComponent } from './primary-account/primary-account.component';
import { AjouterGestionnaireComponent } from './ajouter-gestionnaire/ajouter-gestionnaire.component';
import { DashboradComponent } from './dashborad/dashborad.component';
import { AjouterPartenaireComponent } from './ajouter-partenaire/ajouter-partenaire.component';
import { AjouterSpayComponent } from './ajouter-spay/ajouter-spay.component';
import { AjouterMembreComponent } from './ajouter-membre/ajouter-membre.component';
import { RoleGuardService } from '../service/security/role-guard.service';
import { TaxRulesAdminComponent } from './tax-rules-admin/tax-rules-admin.component';

const routes: Routes = [
  {
    path: 'utilisateur/admin',
    redirectTo: 'utilisateur/admin/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'utilisateur/admin/compte/primaire/information/:id',
    component: InformationComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['ADMIN', 'GESTIONNAIRE'] }
  },
  {
    path: 'utilisateur/admin/compte/affaire/information/:id',
    component: BussnessInformationComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['ADMIN', 'GESTIONNAIRE'] }
  },
  {
    path: 'utilisarteur/admin/compte/affaire/information/:id',
    redirectTo: 'utilisateur/admin/compte/affaire/information/:id',
    pathMatch: 'full'
  },
  {
    path: 'utilisateur/admin/compte/personel',
    component: PrimaryAccountComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['ADMIN', 'GESTIONNAIRE'] }
  },
  {
    path: 'utilisateur/admin/compte/professionel',
    redirectTo: 'utilisateur/admin/compte/personel',
    pathMatch: 'full'
  },
  {
    path: 'utilisateur/admin/compte/gestionnaire',
    component: AjouterGestionnaireComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['ADMIN'] }
  },
  {
    path: 'utilisateur/admin/dashboard',
    component: DashboradComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['ADMIN'] }
  },
  {
    path: 'utilisateur/admin/ajouter/partenaire',
    component: AjouterPartenaireComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['ADMIN'] }
  },
  {
    path: 'utilisateur/admin/ajouter/membre',
    component: AjouterMembreComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['ADMIN', 'SUPERADMIN', 'GESTIONNAIRE'] }
  },
  {
    path: 'utilisateur/admin/ajouter/compte/spay',
    component: AjouterSpayComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['ADMIN'] }
  },
  {
    path: 'utilisateur/admin/tax-rules',
    component: TaxRulesAdminComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['ADMIN'] }
  },
  {
    path: 'utilisateur/admin/ledger/documentation',
    loadComponent: () => import('./ledger-documentation/ledger-documentation.component').then(m => m.LedgerDocumentationComponent),
    canActivate: [RoleGuardService],
    data: { expectedRole: ['ADMIN', 'SUPERADMIN', 'AUDITOR'] }
  },
  {
    path: 'utilisateur/admin/ledger/accounts',
    loadComponent: () => import('./ledger-accounts/ledger-accounts.component').then(m => m.LedgerAccountsComponent),
    canActivate: [RoleGuardService],
    data: { expectedRole: ['ADMIN'] }
  },
  {
    path: 'utilisateur/admin/ledger/transactions',
    loadComponent: () => import('./ledger-transactions/ledger-transactions.component').then(m => m.LedgerTransactionsComponent),
    canActivate: [RoleGuardService],
    data: { expectedRole: ['ADMIN'] }
  },
  {
    path: 'utilisateur/admin/ledger/discrepancies',
    loadComponent: () => import('./ledger-discrepancies/ledger-discrepancies.component').then(m => m.LedgerDiscrepanciesComponent),
    canActivate: [RoleGuardService],
    data: { expectedRole: ['ADMIN', 'SUPERADMIN', 'AUDITOR'] }
  },
  {
    path: 'utilisateur/admin/billing/invoices',
    loadComponent: () => import('./billing-invoices/billing-invoices.component').then(m => m.BillingInvoicesComponent),
    canActivate: [RoleGuardService],
    data: { expectedRole: ['ADMIN'] }
  },
  {
    path: 'utilisateur/admin/bank/deposits',
    loadComponent: () => import('./bank-deposits/bank-deposits.component').then(m => m.BankDepositsComponent),
    canActivate: [RoleGuardService],
    data: { expectedRole: ['ADMIN', 'SUPERADMIN', 'BANK'] }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
